import { useQuery } from '@tanstack/react-query';
import { useParams } from '@/providers/RouterShim';

import type { UnhandledSubmissions } from '../../@types/FormModel';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON, type RequestError } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import usePermissionWebsite from '../permissions/usePermissionWebsite';
import useSite from './useSite';

export const FORM_SUBMISSIONS_UNHANDLED = 'CMS_SERVICE_URI/forms/:branchId/submissions/unhandled';

const useUnhandledFormSubmissions = (): [UnhandledSubmissions | undefined, RequestStateQuery] => {
  const { branchId } = useParams();
  const { getToken } = useAuth();
  const [permission] = usePermissionWebsite();
  const [site] = useSite();

  const { data, isLoading, isSuccess, isError, error } = useQuery<
    UnhandledSubmissions,
    RequestError
  >({
    queryKey: [FORM_SUBMISSIONS_UNHANDLED, branchId],
    queryFn: async () =>
      await getJSON<UnhandledSubmissions>(
        `${process.env.NEXT_PUBLIC_CMS_SERVICE_URI}/forms/${branchId}/submissions/unhandled`,
        getToken()!,
      ),
    enabled: !!permission?.enabled && !!branchId && !!site,
  });

  return [data, { isLoading, isSuccess, isError, error: error || undefined }];
};

export default useUnhandledFormSubmissions;
